import { IPageTabNavLink } from "../interfaces-and-types";

export const paymentsNavLinks: IPageTabNavLink[] = [
  {
    name: "Payments",
    route: "",
  },
  {
    name: "All transactions",
    route: "transactions",
  },
  {
    name: "Invoices",
    route: "invoices",
  },
  {
    name: "Frauds & Risks",
    route: "frauds",
  },
  {
    name: "Payment Links",
    route: "payment-links",
  },
  {
    name: "Subscriptions",
    route: "subscriptions",
  },
];
